import { validate } from 'email-validator';

export interface Validation {
  isValid: boolean;
  validationMessage: string;
}

const spaceCheck = new RegExp('\\S');

export const validateName = (value: string): boolean => {
  return !!value && value.length > 1 && value.length < 256 && spaceCheck.test(String(value));
};

export const validateSurName = (value: string): boolean => {
  return !!value && value.length > 1 && value.length < 256 && spaceCheck.test(String(value));
};

export const validateRequired = (value: string): boolean => {
  return !!value && spaceCheck.test(String(value));
};

export const validatePhone = (value: string): boolean => {
  const regExp = new RegExp('^[-0-9()+ ]+$');

  return value.length > 3 && value.length < 20 && regExp.test(String(value));
};

export const validateEmail = (value: string): boolean => {
  return validate(value);
};
